import React from 'react'
import Button from './Button'
import './RefletRefletBanner.scss'

const RefletRefletBanner = () => {
	return (
		<div className='reflet-reflet-banner'>
			<div className='banner-container'>
				<div className='banner-logo'>
					<img src='/refletreflet-logo.svg' alt='Reflet Reflet - Agence dédiée aux projets culturels et muséaux' />
				</div>
				<div className='banner-content'>
					<h3>Découvrez nos expériences muséales et culturelles innovantes</h3>
					<p className='light'>
						Nous avons créé <strong>Reflet Reflet</strong>, notre agence dédiée aux projets culturels et muséaux. 
						Installations interactives, bornes tactiles, parcours immersifs... découvrez notre expertise spécialisée.
					</p>
					<Button to='https://reflet-reflet.fr' version='2' size='smaller'>
						Visiter Reflet-Reflet.fr
					</Button>
				</div>
			</div>
		</div>
	)
}

export default RefletRefletBanner